import globalAxios from "../GlobalAxios";

const listApi = async () => {
  try {
    const res = await globalAxios.get('/api/cdn/list');
    return res.data;
  } catch (error) {
    console.error("error", error);
  }
}

const deleteApi = async (data) => {
  try {
    const res = await globalAxios.delete('/api/cdn/delete', { data });
    return res.data;
  } catch (error) {
    console.error("error", error);
  }
}

const addApi = async (data) => {
  try {
    const res = await globalAxios.post('/api/cdn/create', data);
    return res;
  } catch (error) {
    console.error("error", error);
  }
}

const statusChangeApi = async (data) => {
  try {
    const res = await globalAxios.post('/api/cdn/changestatus', data);
    return res.data;
  } catch (error) {
    console.error("error", error);
  }
}




export default {
  listApi,
  deleteApi,
  addApi,
  statusChangeApi
};